import { useAutoAnimate } from '@formkit/auto-animate/react';
import { TitleRow } from 'components/TitleRow';
import { FC } from 'react';
import { CheckItem } from 'ui/CheckItem';
import styles from './ChecksList.module.scss';
import { CheckItemType } from 'redux/Api/checksApi/type';

interface GroupsListTypes {
  data?: CheckItemType[];
}

export const ChecksList: FC<GroupsListTypes> = ({ data }) => {
  const [parent] = useAutoAnimate({ duration: 300 });

  const dataTitle = ['ID', 'Дата чека', 'Услуга', 'Исполнитель', 'Сумма, ₽', 'Статус'];

  return (
    <div ref={parent} className={styles.root}>
      <TitleRow data={dataTitle} title='checks' />
      {data?.length ? (
        data?.map((item: CheckItemType) => <CheckItem key={item.id} check={item} />)
      ) : (
        <div className={styles.root_nothing}>
          <p>Ничего не найдено</p>
        </div>
      )}
    </div>
  );
};
